import React, { useContext } from "react";
import "../../../styles/task.scss";
import MentorshipManagementTab from "./MentorshipManagementTab";
import { SidebarContext } from "../../auth/ProtectedRoute";

const Mentorship = () => {
  const { userName, sidebarData } = useContext(SidebarContext);
  return (
    <div style={{ padding: "40px" }} className="roless">
      <div className="roless-wrapper">
        <div className="roless--heading">
          <div className="roless--heading-img">
            {/* Image Placeholder */}
          </div>
        </div>
        <div className="roless--tables">
          <div
            className="roless--tables-heading"
            style={{
              marginBottom: "10px",
            }}
          >
            <div
              className="roless--tables-heading-title"
              style={{
                padding: "5px 0px",
              }}
            >
              <h2>Mentorship Management</h2>
            </div>
            <div className="roless--tables-heading-box">
              <div className="clicks">
                {/* Actions Placeholder */}
              </div>
            </div>
          </div>
          <div className="roless--tables--content">
            <MentorshipManagementTab />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mentorship;